














































































import Vue from "vue";
import {
  getFollowCompanies as getFollowCompaniesRequest,
  getTopCompanyFollowees
} from "@/api";
import LayoutColumnDouble from "@/components/Atoms/Layout/ColumnDouble/index.vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Suffix from "@/components/Atoms/Typography/Suffix/index.vue";
import CompanyCard from "./Molecules/CompanyCard/index.vue";
import FollowSelect from "../Molecules/FollowSelect/index.vue";
import { ApiResponse } from "@/api/types";

export interface Props {}
export interface Data {
  companies: ApiResponse.CompanyWithLikeCount[];
  topCompanies: ApiResponse.CompanyWithLikeCount[];
  companiesLoading: boolean;
  topCompaniesLoading: boolean;
}
export interface Computed {
  filteredTopFollowCompanies: ApiResponse.CompanyWithLikeCount[];
}
export interface Methods {
  getFollowCompanies: () => void;
  getTopFollowCompanies: () => void;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "SettingsFollowsCompanies",
  components: {
    LayoutColumnDouble,
    Heading,
    Suffix,
    CompanyCard,
    FollowSelect
  },
  data() {
    return {
      companies: [],
      topCompanies: [],
      companiesLoading: false,
      topCompaniesLoading: false
    };
  },
  computed: {
    filteredTopFollowCompanies() {
      return this.topCompanies.filter(
        topCompany =>
          !this.companies.some(company => company.id === topCompany.id)
      );
    }
  },
  mounted() {
    this.getFollowCompanies();
    this.getTopFollowCompanies();
  },
  methods: {
    async getFollowCompanies() {
      try {
        this.companiesLoading = true;
        const { data } = await getFollowCompaniesRequest();
        this.companies = data.companies;
      } finally {
        this.companiesLoading = false;
      }
    },
    async getTopFollowCompanies() {
      try {
        this.topCompaniesLoading = true;
        const { data } = await getTopCompanyFollowees({ limit: 10 });
        this.topCompanies = data.companies;
      } finally {
        this.topCompaniesLoading = false;
      }
    }
  }
});
